var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanoCompartido(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Servicios",
    clipPath: "url(#clip0_781_7169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 30.0003L33.3333 35.0003H16.6667L20 30.0003M36.6667 20.0003H13.3333C13.3333 22.6525 14.3869 25.196 16.2623 27.0714C18.1376 28.9468 20.6812 30.0003 23.3333 30.0003H26.6667C29.2551 30.0021 31.7434 29.0002 33.6084 27.2052C35.4733 25.4102 36.5696 22.962 36.6667 20.3753V20.0003ZM13.3333 23.3337H5V6.66699H13.3333V23.3337Z",
    stroke: "#FF7901",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 17.917V16.667C20 16.004 20.2634 15.3681 20.7322 14.8992C21.2011 14.4304 21.837 14.167 22.5 14.167H25C25.663 14.167 26.2989 14.4304 26.7678 14.8992C27.2366 15.3681 27.5 16.004 27.5 16.667V17.917M31.25 17.9172V16.6672C31.2468 16.1155 31.0612 15.5802 30.722 15.145C30.3829 14.7097 29.9093 14.3989 29.375 14.261M28.125 6.74878C28.6628 6.88647 29.1394 7.19922 29.4798 7.63772C29.8201 8.07623 30.0049 8.61555 30.0049 9.17065C30.0049 9.72576 29.8201 10.2651 29.4798 10.7036C29.1394 11.1421 28.6628 11.4548 28.125 11.5925M21.25 9.16699C21.25 9.83003 21.5134 10.4659 21.9822 10.9348C22.4511 11.4036 23.087 11.667 23.75 11.667C24.413 11.667 25.0489 11.4036 25.5178 10.9348C25.9866 10.4659 26.25 9.83003 26.25 9.16699C26.25 8.50395 25.9866 7.86807 25.5178 7.39923C25.0489 6.93038 24.413 6.66699 23.75 6.66699C23.087 6.66699 22.4511 6.93038 21.9822 7.39923C21.5134 7.86807 21.25 8.50395 21.25 9.16699Z",
    stroke: "#FF7901",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_7169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanoCompartido);
export default __webpack_public_path__ + "static/media/banoCompartido.6c75aecbd81c10302a5684c4f7670139.svg";
export { ForwardRef as ReactComponent };